import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { noop } from 'lodash';
import { getAnswerDisplayLabel } from 'containers/QuestionnairePage/selectorUtils';
import Pficon from 'components/Pficon';
import { Divider } from 'antd';
import FormattedInput from 'components/FormattedInput/Loadable';

const QuestionAnswer = ({ answer, hideMedia = false, hideActions = false }) => {
  const { body, isCarriedForward } = answer;
  const showImageIcon = !isCarriedForward && !hideMedia;

  return (
    <div
      className={classnames(
        'flex flex-justify-between  margin-btm-sm position-relative',
        { 'padding-left-lg': !isCarriedForward },
        { 'padding-left-xs': isCarriedForward },
      )}
    >
      <span className="overflow-hidden overflow-ellipsis">
        {isCarriedForward && (
          <Pficon
            className="color-grey-10 margin-right-xxs"
            type="carry-forward-arrow"
          />
        )}
        <span className="color-grey-8 margin-right-sm">
          {getAnswerDisplayLabel(answer)}
        </span>
        <span
          className={classnames(
            { 'color-grey-10': !isCarriedForward },
            { 'color-grey-8': isCarriedForward },
            'text-wrap-none',
          )}
        >
          <FormattedInput
            value={body}
            defaultHtml={body}
            onChange={noop}
            readOnly
            className="display-inline-block no-height"
            inputClassName="padding-vertical-none-important"
          />
        </span>
      </span>
      {!hideActions && (
        <span
          className="color-grey-7"
          style={{
            fontSize: '12px',
            minWidth: showImageIcon ? '105px' : '66px',
          }}
        >
          {showImageIcon && (
            <Fragment>
              <Pficon
                className="margin-horizontal-xxs position-relative"
                type="addimage2"
              />
              <Divider
                type="vertical"
                className="margin-horizontal-xs color-grey-3 position-relative"
                style={{ top: '-2px' }}
              />
            </Fragment>
          )}
          <Pficon className="padding-horizontal-xxs" type="arrow_down" />
          <Pficon className="padding-horizontal-xxs" type="arrow_up" />
          <Divider
            type="vertical"
            className="margin-horizontal-xs color-grey-3 position-relative"
            style={{ top: '-2px' }}
          />
          <Pficon
            className="position-relative"
            type="close"
            style={{ fontSize: '14px', top: '1px' }}
          />
        </span>
      )}
    </div>
  );
};

QuestionAnswer.propTypes = {
  answer: PropTypes.object.isRequired,
  hideMedia: PropTypes.bool,
  hideActions: PropTypes.bool,
};

export default QuestionAnswer;
